"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M16.34 7.2H7.658C6.743 7.2 6 7.937 6 8.844V16.8l2.735-1.778h7.607c.915 0 1.658-.737 1.658-1.645V8.844c0-.907-.743-1.644-1.66-1.644zm-2.776 5.631h-5.41v-.889h5.41v.89zm2.28-2.552h-7.69V9.39h7.69v.89z" }), "Social");
//# sourceMappingURL=Social.js.map